import {
    REQUEST_UPDATE_TRANSPORTER, REQUEST_UPDATE_TRANSPORTER_FAILURE,
    REQUEST_UPDATE_TRANSPORTER_SUCCESS
} from "../../../constant/master/TransTransporterConstant";


const initialState = {
    updateTransporter: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const updateTransporterReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_UPDATE_TRANSPORTER:
            return {
                ...state,
                updateTransporter: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_UPDATE_TRANSPORTER_SUCCESS:
            return {
                ...state,
                updateTransporter: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_UPDATE_TRANSPORTER_FAILURE:
            return {
                ...state,
                updateTransporter: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
